(function()
{
	var Application = include("springroll.Application");
	var Container = include("PIXI.Container");
	var Debug = include("springroll.Debug", false);
	var DebugOptions = include("nature.DebugOptions");
	var Polygon = include("collision.Polygon");

	var UnitContainer = function(panel, config)
	{
		Container.call(this);

		this.panel = panel;
		this.config = config;

		if (config.collision)
		{
			this.collision = new Polygon(config.collision);
			if (DebugOptions.showCollision)
			{
				var graphics = new PIXI.Graphics();
				//set a fill and line style
				graphics.beginFill(0x000000, 0);
				graphics.lineStyle(2, 0xFF0000, 1);
				//draw a shape
				var pts = [];
				for (var i = 0; i < config.collision.length; i++)
				{
					var pt = config.collision[i];
					pts.push(pt.x);
					pts.push(pt.y);
				}
				graphics.drawPolygon(pts);
				graphics.endFill();

				this.addChild(graphics);
			}
		}
	};

	var s = Container.prototype;
	var p = extend(UnitContainer, Container);

	/**
	 * destroy and don't use after this
	 * @method destroy
	 */
	p.destroy = function()
	{
		s.destroy.call(this);
		this.panel = null;
		this.config = null;
		this.collision = null;
	};

	namespace("nature").UnitContainer = UnitContainer;

}());
